<div class="client-filter">
    <mat-form-field class="search" floatLabel='never'>
        <mat-label>Search</mat-label>
        <input [(ngModel)]="filterValue" (keyup.enter)="filter()" matInput>
        <button mat-button matSuffix mat-icon-button aria-label="Clear"
                *ngIf="filterValue" (click)="clear()">
            <mat-icon>close</mat-icon>
        </button>
        <button mat-button matPrefix mat-icon-button>
            <mat-icon class="search-button" (click)="filter()">search</mat-icon>
        </button>
    </mat-form-field>
</div>
